// IMPORTS
// =============================================================
import $ from "jquery";
import { init as initFlyout } from "./modules/flyout.mjs";
import { init as initFlyoutSearch } from "./modules/flyoutSearch.mjs";

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
let attempts = 0;
const whenComplete = () => {
  if (++attempts > 30) return;
  if (document.readyState === "complete") {

    //Main menu
    initFlyout();

    //Site Search
    initFlyoutSearch();

    // -------------------------------------------------------------
    // MD modal
    // Import and init BS5 modal module when a modal is present
    // -------------------------------------------------------------

    if (document.querySelectorAll(".modal").length > 0) {
      import("./modules/modal.mjs").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD swiper
    // Import and init Swiper module when a slider is present
    // -------------------------------------------------------------
    if (document.querySelectorAll(".swiper-container").length > 0) {
      import("./modules/swiper.mjs").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD Autofinder
    // Autocomplete search for clinic finder
    // -------------------------------------------------------------
    if (document.querySelectorAll(".autofinder:not(.treatmentfinder)").length > 0) {
      import("./modules/autofinder.mjs").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD Treatmentfinder
    // Autocomplete search for treatment finder
    // -------------------------------------------------------------
    if (document.querySelectorAll(".autofinder.treatmentfinder").length > 0) {
      import("./modules/treatment-autofinder.mjs").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD readmore-block
    // Import and init Readmore-Block module when a .readmore-block is present
    // -------------------------------------------------------------
    if (document.querySelectorAll(".read-more-marker").length > 0) {
      import("./modules/readmore.mjs").then((module) => {
        module.init();
      });
    }

    // ------------------------------------------------------------
    // MD video-modal
    // Import and init video modal module when a modal for video is present
    // -------------------------------------------------------------

    if (document.getElementById("videoModal")) {
      import("./modules/videoModal.mjs").then((module) => {
        module.init();
      });
    }

    /*------------ .acc ---------*/
    $(".acc .acc__btn").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      var isActive = $this.parents('.acc__item').hasClass("active");

      var $acc = $this.closest(".acc");
      if ($acc.hasClass('active-one')) {
        $acc.find('.acc__item.active').removeClass('active').find('.acc__panel').slideUp(500);
      }

      if (isActive) {
        $this.attr('aria-expanded', 'false').parents('.acc__item').removeClass('active').find('.acc__panel').slideUp(500);
      } else {
        $this.attr('aria-expanded', 'true').parents('.acc__item').addClass('active').find('.acc__panel').slideDown(500);
      }
    });
    /*-------- /.acc ----------*/

    /* ------- Alternative Select -------- */
    if (document.querySelectorAll(".alt-select").length > 0) {
      import("./modules/altSelect.mjs").then((module) => {
        module.init();
      });
    }

    // lightbox
    if (document.querySelectorAll(".lightbox").length > 0) {
      import("./modules/lightbox.mjs").then((module) => {
        module.init();
      });
    }

    if (document.querySelectorAll(".clinic-popover-trigger").length > 0) {
      import("./modules/siteNavPopover.mjs").then((module) => {
        module.init();
      });
    }

    if (document.querySelectorAll('input[type="date"]').length > 0) {
      import("./modules/dateInput.mjs").then((module) => {
        module.init();
      });
    }

    if(document.querySelectorAll(".clear-input").length > 0) {
      import("./modules/clearSearchInput.mjs").then((module) => {
        module.init();
      });
    }

    // add wrapping <wbr> to indexed search result paths to allow breaking long paths
    document.querySelectorAll('.tx-indexedsearch-text-item-path a').forEach(a => {
      const t = a.textContent;
      a.innerHTML =
        t.startsWith('/')
          ? '/' + t.slice(1).replaceAll('/', '<wbr>/')
          : t.replaceAll('/', '<wbr>/');
    });


  } else {
    setTimeout(() => whenComplete(), 400);
  }
};
whenComplete();

// =============================================================
// STYLES COMPLETE
// Removes styles_essential when general styles are loaded
// =============================================================
let styleAttempts = 0;
const stylesComplete = () => {
  if (++styleAttempts > 30) return;
  if (document.querySelector("#spreld").getAttribute("rel") === "stylesheet") {
    document.querySelector("#sess").remove();
  } else {
    setTimeout(() => stylesComplete(), 300);
  }
};
stylesComplete();
